import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  DataTable,
  DataTablePageEvent,
  DataTableRowClickEvent,
} from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import {
  formatDateTime,
  parseQueryString,
  toQueryString,
} from "../../common/utils";
import { useInteractions } from "../../api/queries/interactions/useInteractions";
import { Interaction } from "../../api/types/interaction";

export default function InteractionList() {
  const navigate = useNavigate();
  const limit = 20;
  const queryParams = parseQueryString(useLocation().search);

  const [offset, setOffset] = useState(0);
  const [total, setTotal] = useState(0);
  const [sortField, setSortField] = useState(queryParams.sortField);
  const [sortOrder, setSortOrder] = useState(queryParams.sortOrder);

  const onPage = ({ first }: DataTablePageEvent) => setOffset(first);
  const onSort = (event: any) => {
    setSortField(event.sortField);
    setSortOrder(event.sortOrder);
  };

  const { data: interactions, isLoading } = useInteractions({
    limit,
    offset,
  });

  const onRowClick = (event: DataTableRowClickEvent) =>
    navigate(`/interactions/${event.data.id}`);

  const tName = (row: Interaction) => row.name;

  const tDescription = (row: Interaction) => (
    <span dangerouslySetInnerHTML={{ __html: row.description }} />
  );

  const tTimeSpent = (row: Interaction) => row.time_spent;

  const tCompleted = (row: Interaction) => (
    <i className={row.completed ? "fa fa-check" : "fa fa-times"} />
  );

  const tDueDate = (row: Interaction) => formatDateTime(row.due_date);

  useEffect(() => {
    const queryParamsStr = toQueryString({
      limit: 20,
      offset,
      sortField,
      sortOrder,
    });
    navigate({ search: queryParamsStr });
  }, [offset, navigate, sortField, sortOrder]);

  useEffect(() => {
    if (interactions) {
      setTotal(interactions.data.total_count);
    }
  }, [interactions]);

  return (
    <div className={"col-12"}>
      <div className="flex py-3">
        <h1 className="m-0">Interaction</h1>

        <Button
          onClick={() => navigate("/interactions/new")}
          className="p-button p-button-main p-button-sm ml-auto"
          label="Add new"
        />
      </div>

      <DataTable
        emptyMessage={"No records"}
        paginator={true}
        lazy={true}
        rows={20}
        first={offset}
        totalRecords={total}
        loading={isLoading}
        sortField={sortField}
        sortOrder={sortOrder}
        onPage={onPage}
        onSort={onSort}
        value={interactions?.data.results || []}
        className="p-datatable-sm p-datatable-pointer"
        onRowClick={onRowClick}
        stripedRows={true}
      >
        <Column header={"Name"} body={tName} />

        <Column header={"Description"} body={tDescription} />

        <Column header={"Spent time"} body={tTimeSpent} />

        <Column header={"Completed"} body={tCompleted} />

        <Column header={"Due date"} body={tDueDate} />
      </DataTable>
    </div>
  );
}
